import React, { useEffect, useState } from 'react';
import LoadingIndicator from '../LoadingIndicator';
import styles from './Precalc.scss';

export interface IPrecalcProps {
    nextStep: (name: string, value: string | number) => void;
}

const numberPrecalcSteps = 5;

const Precalc: React.FC<React.PropsWithChildren<IPrecalcProps>> = ({ nextStep = () => {} }) => {
    const [step, setStep] = useState(0);

    useEffect(() => {
        setTimeout(() => {
            if (step + 1 < numberPrecalcSteps) {
                setStep(step + 1);
            } else {
                nextStep('precalc', 1);
            }
        }, 1000);
    }, [step]);

    return (
        <div className={styles.precalc}>
            <LoadingIndicator />

            {step === 0 && <p>Suche Immobilien in der Nachbarschaft</p>}
            {step === 1 && <p>Errechne Bodenwert</p>}
            {step === 2 && <p>Errechne Wohnflächenwert</p>}
            {step === 3 && <p>Errechne Ausstattung</p>}
            {step === 4 && <p>Errechne Gesamtpreis</p>}
        </div>
    );
};

export default Precalc;
